import { Dashboard } from "@/pages/Dashboard";
import { lazy } from "react";
const Login = lazy(() => import("@/pages/Login"));
const SignUp = lazy(() => import("@/pages/Signup"));
const Logout = lazy(() => import("@/pages/Logout"));
const EmailVerification = lazy(() => import("@/pages/EmailVerification"));
const LinkedInCallback = lazy(() => import("@/pages/LinkedInCallback"));
const SetupWizard = lazy(() => import("@/pages/SetupWizard"));
const SetupOrganization = lazy(() => import("@/pages/SetupOrganization"));
const OrganizationSettings = lazy(
  () => import("@/pages/OrganizationSettings"),
);
const OAuthConsent = lazy(() => import("@/pages/OAuthConsent"));
const Assistant = lazy(() => import("@/pages/Assistant"));
const Library = lazy(() => import("@/pages/Library"));
const ScheduledJobs = lazy(() => import("@/pages/ScheduledJobs"));
const Recipes = lazy(() => import("@/pages/Recipes"));
const SearchConsoleTest = lazy(() => import("@/pages/SearchConsoleTest"));

// Auth routes that redirect authenticated users to dashboard
export const authRoutes = [
  {
    path: "/login",
    Component: Login,
  },
  {
    path: "/signup",
    Component: SignUp,
  },
];

// Public routes available for everyone
export const publicRoutes = [
  {
    path: "/logout",
    Component: Logout,
  },
  {
    path: "/verify-email",
    Component: EmailVerification,
  },
  {
    path: "/auth/linkedin/callback",
    Component: LinkedInCallback,
  },
];

export const protectedRoutes = [
  {
    path: "/setup-organization",
    Component: SetupOrganization,
  },
  {
    path: "/setup-wizard",
    Component: SetupWizard,
  },
  {
    path: "/organization",
    Component: OrganizationSettings,
  },
  // Protected on purpose: an unauthenticated visitor is bounced to /login and
  // `PublicRoute` returns them here afterwards with the authorization request's
  // query string intact.
  {
    path: "/oauth/consent",
    Component: OAuthConsent,
  },
  {
    path: "/dashboard",
    Component: Dashboard,
  },
  {
    path: "/assistant",
    Component: Assistant,
  },
  {
    path: "/library",
    Component: Library,
  },
  {
    path: "/jobs",
    Component: ScheduledJobs,
  },
  {
    path: "/recipes",
    Component: Recipes,
  },
  {
    path: "/search-console-test",
    Component: SearchConsoleTest,
  },
];
